module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main products feature"
  }, [_c('div', {
    staticClass: "mainContent"
  }, [_c('div', {
    staticClass: "feature-compare"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "row-class-name": "self-row",
      "header-row-class-name": "table-title title",
      "cell-class-name": "feature-compare-detail"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "features",
      "label": _vm.$t('p-title1')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n             " + _vm._s(_vm.$t(scope.row.features)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "crait",
      "label": _vm.$t('p-title2')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.crait === 'getStarted') ? _c('el-button', {
          staticClass: "cur get-start",
          on: {
            "click": _vm.getStarted
          }
        }, [_vm._v(_vm._s(_vm.$t('btn1')))]) : (scope.row.crait === 'Support') ? _c('div', [_c('i', {
          staticClass: "el-icon-check"
        })]) : (scope.row.crait === 'Not Support') ? _c('div', [_c('i', {
          staticClass: "el-icon-close"
        })]) : (scope.row.crait !== 'Support' && scope.row.crait !== 'Not Support') ? _c('div', [_vm._v(_vm._s(_vm.$t(scope.row.crait)))]) : _vm._e()]
      }
    }])
  }, [_vm._v("\n          align=\"center\">\n          ")]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "craitPro",
      "label": _vm.$t('p-title3')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.craitPro === 'Upgrade') ? _c('el-button', {
          staticClass: "cur upgrade",
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.upgrade
          }
        }, [_vm._v(_vm._s(_vm.$t('btn2')))]) : (scope.row.craitPro === 'Support') ? _c('div', [_c('i', {
          staticClass: "el-icon-check"
        })]) : (scope.row.craitPro === 'Not Support') ? _c('div', [_c('i', {
          staticClass: "el-icon-close"
        })]) : (scope.row.craitPro !== 'Support' && scope.row.craitPro !== 'Not Support') ? _c('div', [_vm._v(_vm._s(_vm.$t(scope.row.craitPro)))]) : _vm._e()]
      }
    }])
  }, [_vm._v("\n          align=\"center\">\n          ")])], 1)], 1)]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('wx-mask', {
    attrs: {
      "maskShow": _vm.showWxMask
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-755c947d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Prices/index.vue
// module id = 299
// module chunks = 1